module.exports = {
	"No notifications found.": "No notifications found.",
	"Notifications": "Notifications",
	"See all notifications": "See all notifications",
	"Mark all as read": "Mark all as read"
};


//////////////////
// WEBPACK FOOTER
// ./~/@99designs/globalnav/translations/en.json
// module id = 925
// module chunks = 40